import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

import {
    crearNotificacioFotoSuperaMidaPermesa,
    crearNotificacioFotoTipusNoPermes
} from '../../commons/notificacio';

import {
    extensionsPermesesEnString,
    fitxerTipusNoPermes
} from '../../commons/gestioImatges';

import ImatgeAmbControlError from '../commons/imatgeAmbControlError';

const unitatImatge = 'MB';

const converteixBytesAMB = (midaEnBytes) => {
    return ((midaEnBytes/1000)/1000).toFixed(2);
};

const fitxerSuperaMidaMaximaPermesa = (midaFitxerEnMB, midaMaximaFotosEnMB) => {
    return midaFitxerEnMB > midaMaximaFotosEnMB;
};

class EstacioIntroduccioSelectorImatge extends Component {

    constructor(props) {
        super(props);

        this.modificarImatgeSeleccionada = this.modificarImatgeSeleccionada.bind(this);
        this.seleccionarImatge = this.seleccionarImatge.bind(this);
        this.eliminarImatgeSeleccionada = this.eliminarImatgeSeleccionada.bind(this);
    }

    modificarImatgeSeleccionada(fitxer) {
        const { midaMaximaFotosEnBytes } = this.props;
        const midaMaximaFotosEnMB = converteixBytesAMB(midaMaximaFotosEnBytes);
        const midaFitxerEnMB = converteixBytesAMB(fitxer.size);
        const tipusFitxer = fitxer.type;

        if (fitxerTipusNoPermes(tipusFitxer)) {
            crearNotificacioFotoTipusNoPermes();
            return;
        }

        if (fitxerSuperaMidaMaximaPermesa(midaFitxerEnMB, midaMaximaFotosEnMB)) {
            crearNotificacioFotoSuperaMidaPermesa(midaFitxerEnMB, unitatImatge, midaMaximaFotosEnMB);
            return;
        }

        const obtenirUrlImatgeSeleccionada = (fitxer) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const { crearFoto } = this.props;
                crearFoto({url: event.target.result, fitxer: fitxer}); //{File}
            };
            reader.readAsDataURL(fitxer);
        };

        obtenirUrlImatgeSeleccionada(fitxer);
    }

    seleccionarImatge() {
        // si l'input té emmagatzemada una imatge, cal netejar-lo
        if (this.inputHTML5.value) {
            this.inputHTML5.value = '';
        }

        //es força un clic a l'element input d'HTML5
        this.inputHTML5.click();
    }

    eliminarImatgeSeleccionada() {
        const { eliminarFoto } = this.props;
        eliminarFoto();
    }

    render() {
        const urlImatgeSeleccionada = this.props.urlImatgeOriginal;

        // input de tipus "file" d'HTML5, resta ocult però s'usa la funcionalitat de seleccionar arxiu
        const inputHTML5 = (
            <input
                ref={ref => this.inputHTML5 = ref}
                type='file'
                accept={extensionsPermesesEnString}
                onChange={(event) => this.modificarImatgeSeleccionada(event.target.files[0])} />
        );

        // previsualització de la imatge seleccionada
        const previsualitzacioImatge = (
            <div className='estacio-introduccio-selector-imatge-contenidor-imatge-seleccionada'>
                <ImatgeAmbControlError url={urlImatgeSeleccionada}/>
                <div className='estacio-introduccio-selector-imatge-contenidor-imatge-seleccionada-eliminar'>
                    <Icon
                        style={{color: 'white', fontSize: 20}}
                        type='delete'
                        onClick={this.eliminarImatgeSeleccionada} />
                </div>
            </div>
        );

        // zona que cal clicar quan es vol seleccionar una imatge
        const selectorImatge = (
            <div className='estacio-introduccio-selector-imatge-contenidor-imatge-afegir'
                onClick={this.seleccionarImatge}>
                <Icon type='plus' style={{fontSize: 20}} />
            </div>
        );

        return (
            <div className='estacio-introduccio-selector-imatge'>
                {inputHTML5}
                {urlImatgeSeleccionada ? previsualitzacioImatge : selectorImatge}
            </div>
        );
    }
}

EstacioIntroduccioSelectorImatge.propTypes = {
    urlImatgeOriginal: PropTypes.string,
    midaMaximaFotosEnBytes: PropTypes.number,
    eliminarFoto: PropTypes.func,
    crearFoto: PropTypes.func
};

export default EstacioIntroduccioSelectorImatge;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioSelectorImatge.js